import React from 'react';

import logo from './flexera-branding-logo.png';

const Footer = () => {
    return (
        <footer role="contentinfo">
            <div className="text-center">
                <img id="footer-logo" alt="Flexera Technopedia logo" src={logo} height="25" />
                <div className="links" role="navigation" aria-labelledby="secondary">
                    <p>
                        <a target="_blank" id="footer-link1" title="View our Privacy Policy. This link will open in a new window." rel="noopener noreferrer" href="https://www.flexera.com/enterprise/company/terms/tab/privacy"> Privacy Policy </a> |
                        <a target="_blank" id="footer-link2" title="View our Terms of Use. This link will open in a new window." rel="noopener noreferrer" href="https://www.flexera.com/enterprise/company/terms/tab/use"> Terms of Use </a> |
                        <a target="_blank" id="footer-link3" title="View our Support Material. This link will open in a new window." rel="noopener noreferrer" href="https://www.flexera.com/enterprise/support/top-support-resources"> Support </a> |
                        <a target="_blank" id="footer-link4" title="View our Contact details. This link will open in a new window." rel="noopener noreferrer" href="https://www.flexera.com/enterprise/company/about/contact-us"> Contact Us </a>
                    </p>
                </div>
                <p id="footer-copy" className="copyright">&#169; 2018 Flexera. All rights reserved.</p>
            </div>
        </footer>
    );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js